import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var fastReturnsIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16.121 19.14-4.081 1.92V11.2l8.031-3.8v.05c0 .832.668 1.5 1.5 1.5V6.22a.775.775 0 0 0-.308-.61c-.043-.03-.09-.03-.133-.05v-.03l-9.19-4.382a1.475 1.475 0 0 0-1.293 0L1.43 5.531v.02s-.07.02-.102.039A.76.76 0 0 0 1 6.219v11.543a.76.76 0 0 0 .43.68l9.539 4.5a.764.764 0 0 0 .64 0l6.063-2.864-.211-.45a1.012 1.012 0 0 0-1.332-.48m-7.82-10.66 7.793-3.68 2.976 1.422-7.777 3.68L8.309 8.5zM11.3 2.52l3.05 1.449-7.8 3.691-3.04-1.43zM2.5 7.398l3.27 1.543v1.38c0 .577.332 1.109.859 1.359l.652.308V9.66l3.27 1.54v9.87l-8.04-3.789V7.398zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.012 15a1.5 1.5 0 0 0 1.5-1.5H14.5A1.5 1.5 0 0 0 13 15zm-2.024-4.48a1.5 1.5 0 0 0-1.5 1.5H21.5c.828 0 1.5-.668 1.5-1.5zM14 18h6.012a1.5 1.5 0 0 0 1.5-1.5H15.5A1.5 1.5 0 0 0 14 18"
}));

export { fastReturnsIcon as default };
//# sourceMappingURL=fastReturnsIcon.js.map
